<template>
<div id="dataset-elem">
  <div class="content-header text-center">
    <div class="float-end text-right">
      <button type="button" @click="sortData"><i class="fa" :class="sorticon"></i></button>
    </div>
    <h2>Script Results</h2>
  </div>
  <div class="container-fluid min-content-height">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="btn-group-vertical col-12" v-for='(value, name, index) in scriptresults'>
          <div class="btn-group mb-2" role="group" aria-label="DatasetExists">
            <a class="btn col-8 btn-lg btn-primary" :href="generateLink(name,value)" target="_blank"><span class="sidebar-text">{{name}}</span></a>
            <a class="btn col-2 btn-lg btn-warning"  @click="$emit('openModal', {view: 'RenameScript', dt: name})"><i class="fas fa-edit"></i></a>
            <a class="btn col-2 btn-lg btn-danger" @click="deleteScript(name)"><i class="fas fa-trash-alt"></i></a>
            <!-- a v-if="this.userData.organization == 'my_organization'" class="btn col-2 btn-lg btn-warning" @click="$emit('openModal', {view: 'TransferDatasetForm', dt: String(data)})"><i class="fas fa-random"></i></a -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'ScriptResults',
    props: {
      passedModalData: '',
      userData: []
    },
    data() {
      return {
        scriptresults: [],
        scriptstatus: [],
        sorticon: 'fa-sort-alpha-down'
      }
    },
    methods: {
      generateLink(n,m) {
        var finlink = '/script_download?scriptname='+n+'&scriptresult='+m;
        return finlink;
      },
      checkScriptStatus(r) {
        let formData = new FormData();
        formData.append('run_id', r);
          axios.post('/script_complete', formData)
          .then(
            (response) => {
              console.log('script response '+JSON.stringify(response.data));
              return JSON.stringify(response.data);
            }
          )
          .catch(
            (error) => {
              this.errorMessage = error.message;
              console.error("There was an error!", error);
              }
          )
      },
      deleteScript(name) {
        console.log('Delete the script: scripts/'+name+'/results.txt');
        this.$emit('deleteScript', {filename: 'results.txt', directory: name})
        this.compileScripts();
      },
      iterateScriptStatus() {
        console.log('script results length '+this.scriptresults.length);
            for (var i = 0; i < this.scriptresults.length; i++) {
              var curstat = this.checkScriptStatus(this.scriptresults[i]);
              this.scriptstatus.push(curstat); 
              console.log('iterate script '+this.scriptresults[i]+' and status is '+curstat);
            };
            console.log('script status whole '+JSON.stringify(this.scriptstatus));
      },
      compileScripts() {
        axios({
            method : 'POST',
            url : '/script_results'
        }).then(
                (response) => {
                this.scriptresults = response.data;
                        console.log('SCRIPT RESULTS response: '+JSON.stringify(this.scriptresults));
                // setInterval(this.iterateScriptStatus(this.scriptresults), 300);
                this.iterateScriptStatus(this.scriptresults)
            })
            .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });

      },
      sortData() {
      let entries = Object.entries(this.scriptresults);
        if (this.sorticon == 'fa-sort-alpha-down') {
            this.sorticon = 'fa-sort-alpha-up';
            entries.sort((a, b) => b[0].localeCompare(a[0]));
        } else {
            this.sorticon = 'fa-sort-alpha-down';
            entries.sort((a, b) => a[0].localeCompare(b[0]));
        }
        this.scriptresults = Object.fromEntries(entries);
    }
    },
     mounted() {
        this.compileScripts();
    }
}
</script>